import type { LdsVideoPlayer } from "@lds/core/lds-video-player.d.ts"
import type { default as VideoJsPlayer } from "video.js/dist/types/player"
import { gallerySlider } from "./gallery-slider"
import "@lds/core/lds-video-player.js"

// ToDo: Instead of this convoluted way of initializing videos, we should use metadata in the generator to add data-width
function updateVideoPlayerSize(videoPoster: HTMLImageElement | null, videoPlayer: LdsVideoPlayer): void {
    const videoSlide = videoPlayer.closest(".video-slide") as HTMLElement | null
    if (!videoPoster || !videoSlide) {
        return
    }
    setTimeout(() => {
        const width = videoPoster.naturalWidth
        const height = videoPoster.naturalHeight

        videoSlide.style.setProperty("--video-width", `${width}`)
        videoSlide.style.setProperty("--video-height", `${height}`)
    }, 0)
}

//  and data-height attributes to the video player element, once it is implemented in the events
export function initializeVideos(): void {
    const videoPlayers: Array<LdsVideoPlayer> = [
        ...(gallerySlider()?.querySelectorAll("lds-video-player") as NodeListOf<LdsVideoPlayer>),
    ]

    for (const videoPlayer of videoPlayers) {
        videoPlayer.addEventListener("ready", (): void => {
            if (!videoPlayer.player.videoWidth()) {
                videoPlayer.player.on("loadedmetadata", () => updatePlayerDimensions(videoPlayer).then())
            } else {
                updatePlayerDimensions(videoPlayer).then()
            }
        })

        const videoPoster = videoPlayer.querySelector(".video-poster") as HTMLImageElement | null
        const overlay = videoPlayer.parentElement?.querySelector(".ladies-plus-thumb-overlay .plus-logo")
        const uncensoredOverlay = videoPlayer.parentElement?.querySelector(
            ".ladies-plus-thumb-overlay .video-play-plus",
        )

        if (!videoPoster?.complete) {
            videoPoster?.addEventListener("load", (): void => {
                updateVideoPlayerSize(videoPoster, videoPlayer)
            })
        } else {
            updateVideoPlayerSize(videoPoster, videoPlayer)
        }

        videoPlayer.renderRoot.addEventListener("ready", (): void => {
            videoPlayer.root.querySelector(".vjs-control-bar")?.classList.add("swiper-no-swiping")
        })

        videoPoster?.addEventListener("click", (): void => {
            videoPoster.classList.add("hidden")
            overlay?.classList.add("hidden")
            uncensoredOverlay?.classList.add("hidden")
            videoPlayer.init()
        })
    }
}

export function pauseVideos(): void {
    const videoPlayers: Array<LdsVideoPlayer> = [
        ...(gallerySlider()?.querySelectorAll("lds-video-player") as NodeListOf<LdsVideoPlayer>),
    ]

    for (const videoPlayer of videoPlayers) {
        if (videoPlayer.inited) {
            videoPlayer.player.pause()
        }
    }
}

async function updatePlayerDimensions(videoPlayer: LdsVideoPlayer): Promise<void> {
    const player: VideoJsPlayer = videoPlayer.player
    player.pause()

    const videoWidth: number = player.videoWidth()
    const videoHeight: number = player.videoHeight()

    const videoSlide: HTMLElement | null = videoPlayer.closest(".video-slide") as HTMLElement | null
    if (!videoSlide) {
        return
    }

    player.on("play", (): void => {
        videoSlide.querySelector(".ladies-plus-thumb-overlay .plus-logo")?.classList.add("hidden")
        videoSlide.querySelector(".ladies-plus-thumb-overlay .video-play-plus")?.classList.add("hidden")
    })
    player.on("pause", (): void => {
        videoSlide.querySelector(".ladies-plus-thumb-overlay .plus-logo")?.classList.remove("hidden")
        videoSlide.querySelector(".ladies-plus-thumb-overlay .video-play-plus")?.classList.remove("hidden")
    })

    videoSlide.style.setProperty("--video-width", `${videoWidth}`)
    videoSlide.style.setProperty("--video-height", `${videoHeight}`)
}
